import {SupportTicketFilterTypeEnum} from "../API";

export const SUPPORT_TOP_BAR_FILTER_PARAM = "topBarFilter";

export const supportTopBarFilterByCallout: Partial<Record<string, SupportTicketFilterTypeEnum>> = {
    UnfinishedTasks: SupportTicketFilterTypeEnum.UNFINISHED_TASKS,
    DelegatedToMe: SupportTicketFilterTypeEnum.DELEGATED_TO_ME,
    WaitingFor: SupportTicketFilterTypeEnum.WAITING_FOR,
    UnreadMessages: SupportTicketFilterTypeEnum.UNREAD_MESSAGES,
    UnfinishedTickets: SupportTicketFilterTypeEnum.UNFINISHED_TICKETS,
    UnassignedTickets: SupportTicketFilterTypeEnum.UNASSIGNED_TICKETS,
};

export const supportTopBarFilterLabelKeys: Partial<Record<SupportTicketFilterTypeEnum, string>> = {
    [SupportTicketFilterTypeEnum.UNFINISHED_TASKS]: "UnfinishedTasks",
    [SupportTicketFilterTypeEnum.DELEGATED_TO_ME]: "DelegatedToMe",
    [SupportTicketFilterTypeEnum.WAITING_FOR]: "WaitingFor",
    [SupportTicketFilterTypeEnum.UNREAD_MESSAGES]: "UnreadMessages",
    [SupportTicketFilterTypeEnum.UNFINISHED_TICKETS]: "UnfinishedTickets",
    [SupportTicketFilterTypeEnum.UNASSIGNED_TICKETS]: "UnassignedTickets",
};

export const serializeSupportTopBarFilter = (filterType: SupportTicketFilterTypeEnum): string => {
    return SupportTicketFilterTypeEnum[filterType] ?? `${filterType}`;
};

export const parseSupportTopBarFilter = (
    value?: string | null,
): SupportTicketFilterTypeEnum | undefined => {
    if (!value) {
        return undefined;
    }

    const byName = (SupportTicketFilterTypeEnum as any)[value];
    if (typeof byName === "number") {
        return byName;
    }

    const byNumber = Number(value);
    if (!Number.isNaN(byNumber) && SupportTicketFilterTypeEnum[byNumber] != null) {
        return byNumber as SupportTicketFilterTypeEnum;
    }

    return undefined;
};

export interface LayeredSupportFilter<TFilter> {
    persistentFilter: TFilter;
    temporaryFilter?: TFilter;
}

export const getEffectiveSupportFilter = <TFilter,>(
    state: LayeredSupportFilter<TFilter>,
): TFilter => state.temporaryFilter ?? state.persistentFilter;

export const updateEffectiveSupportFilter = <TFilter,>(
    state: LayeredSupportFilter<TFilter>,
    nextFilter: TFilter,
): LayeredSupportFilter<TFilter> =>
    state.temporaryFilter == null
        ? {...state, persistentFilter: nextFilter}
        : {...state, temporaryFilter: nextFilter};

export const normalizePersistedSupportFilter = <
    TFilter extends {filterType?: SupportTicketFilterTypeEnum | null},
>(filter: TFilter, defaultFilter: TFilter): TFilter =>
    filter.filterType == null ? filter : defaultFilter;

export const clearSupportTopBarFilterFromSearch = (search: string): string => {
    const searchParams = new URLSearchParams(search);
    searchParams.delete(SUPPORT_TOP_BAR_FILTER_PARAM);
    return searchParams.toString();
};
